/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewFindingLevel } from './CRSFSecReviewFindingLevel';
import {
    CRSFSecReviewFindingLevelFromJSON,
    CRSFSecReviewFindingLevelFromJSONTyped,
    CRSFSecReviewFindingLevelToJSON,
} from './CRSFSecReviewFindingLevel';
import type { CRSFSecReviewFindingResolutionItem } from './CRSFSecReviewFindingResolutionItem';
import {
    CRSFSecReviewFindingResolutionItemFromJSON,
    CRSFSecReviewFindingResolutionItemFromJSONTyped,
    CRSFSecReviewFindingResolutionItemToJSON,
} from './CRSFSecReviewFindingResolutionItem';
import type { CRSFSecReviewFindingSourceType } from './CRSFSecReviewFindingSourceType';
import {
    CRSFSecReviewFindingSourceTypeFromJSON,
    CRSFSecReviewFindingSourceTypeFromJSONTyped,
    CRSFSecReviewFindingSourceTypeToJSON,
} from './CRSFSecReviewFindingSourceType';

/**
 * 
 * @export
 * @interface CRSFSecReviewFindingRecordAPIResponse
 */
export interface CRSFSecReviewFindingRecordAPIResponse {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    asset: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    created: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    datapoint: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    description?: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    evidences: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    finding_id: string;
    /**
     * 
     * @type {CRSFSecReviewFindingSourceType}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    finding_source?: CRSFSecReviewFindingSourceType;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    found: number;
    /**
     * 
     * @type {CRSFSecReviewFindingLevel}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    level: CRSFSecReviewFindingLevel;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    matches: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    module: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    port?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    protocol?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    recommendation?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    references?: Array<string>;
    /**
     * 
     * @type {Array<CRSFSecReviewFindingResolutionItem>}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    resolution_events?: Array<CRSFSecReviewFindingResolutionItem>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    resolution_types?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    risk?: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    risk_score: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    scope?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    score_category: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    se_version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    shared: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    source_asset: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingRecordAPIResponse
     */
    title: string;
}

/**
 * Check if a given object implements the CRSFSecReviewFindingRecordAPIResponse interface.
 */
export function instanceOfCRSFSecReviewFindingRecordAPIResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "datapoint" in value;
    isInstance = isInstance && "evidences" in value;
    isInstance = isInstance && "finding_id" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "level" in value;
    isInstance = isInstance && "matches" in value;
    isInstance = isInstance && "module" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "risk_score" in value;
    isInstance = isInstance && "score_category" in value;
    isInstance = isInstance && "shared" in value;
    isInstance = isInstance && "source_asset" in value;
    isInstance = isInstance && "tags" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function CRSFSecReviewFindingRecordAPIResponseFromJSON(json: any): CRSFSecReviewFindingRecordAPIResponse {
    return CRSFSecReviewFindingRecordAPIResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewFindingRecordAPIResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewFindingRecordAPIResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'created': json['created'],
        'datapoint': json['datapoint'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'evidences': json['evidences'],
        'finding_id': json['finding_id'],
        'finding_source': !exists(json, 'finding_source') ? undefined : CRSFSecReviewFindingSourceTypeFromJSON(json['finding_source']),
        'found': json['found'],
        'level': CRSFSecReviewFindingLevelFromJSON(json['level']),
        'matches': json['matches'],
        'module': json['module'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'process_id': json['process_id'],
        'protocol': !exists(json, 'protocol') ? undefined : json['protocol'],
        'recommendation': !exists(json, 'recommendation') ? undefined : json['recommendation'],
        'references': !exists(json, 'references') ? undefined : json['references'],
        'resolution_events': !exists(json, 'resolution_events') ? undefined : ((json['resolution_events'] as Array<any>).map(CRSFSecReviewFindingResolutionItemFromJSON)),
        'resolution_types': !exists(json, 'resolution_types') ? undefined : json['resolution_types'],
        'risk': !exists(json, 'risk') ? undefined : json['risk'],
        'risk_score': json['risk_score'],
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'score_category': json['score_category'],
        'se_version': !exists(json, 'se_version') ? undefined : json['se_version'],
        'shared': json['shared'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'source_asset': json['source_asset'],
        'tags': json['tags'],
        'title': json['title'],
    };
}

export function CRSFSecReviewFindingRecordAPIResponseToJSON(value?: CRSFSecReviewFindingRecordAPIResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'created': value.created,
        'datapoint': value.datapoint,
        'description': value.description,
        'evidences': value.evidences,
        'finding_id': value.finding_id,
        'finding_source': CRSFSecReviewFindingSourceTypeToJSON(value.finding_source),
        'found': value.found,
        'level': CRSFSecReviewFindingLevelToJSON(value.level),
        'matches': value.matches,
        'module': value.module,
        'port': value.port,
        'process_id': value.process_id,
        'protocol': value.protocol,
        'recommendation': value.recommendation,
        'references': value.references,
        'resolution_events': value.resolution_events === undefined ? undefined : ((value.resolution_events as Array<any>).map(CRSFSecReviewFindingResolutionItemToJSON)),
        'resolution_types': value.resolution_types,
        'risk': value.risk,
        'risk_score': value.risk_score,
        'scope': value.scope,
        'score_category': value.score_category,
        'se_version': value.se_version,
        'shared': value.shared,
        'source': value.source,
        'source_asset': value.source_asset,
        'tags': value.tags,
        'title': value.title,
    };
}

